import React from 'react'
import { useTranslation } from 'react-i18next'
import photo from '../../../media/img/products/cerrar-mano-sosteniendo-smartphone.jpg'
import './productoInfoHeader.scss'

const ProductoInfoHeader = () => {
    const { t } = useTranslation();

    return (
        <div className="producto-info-header">
            <div className="producto-info-header__img-container">
                <div className="triangle-left"></div>
                <img className="producto-info-header__img" src={photo} alt={t('products.header.title')} />
                <div className="triangle-right"></div>
            </div>

            <div className="producto-info-header__content">
                <div className="producto-info-header__title">
                    <h1 className="producto-info-header__title-text header-title__sub-page">{t('products.header.title')}</h1>
                </div>
                
                <div className="producto-info-header__text">
                    <p className="producto-info-header__text-paragraph header-subtitle__sub-page">
                        {t('products.header.subtitle')}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ProductoInfoHeader